<template>
  <div style="width:100%">
    <v-layout
      rows
      wrap
      align-start
    >
      <v-flex xs9>
        <h1>Audit Log
          <v-btn small
            @click="search"
          >refresh
        </v-btn>
        </h1>
        <v-form>
          <v-container />
        </v-form>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-data-table
          :headers="table.headers"
          :items="items"
          :dense="true"
          :search="table.search"
          :sort-by="['when_entered']"
          :sort-desc="true"
          :hide-default-footer="true"
          :disable-pagination="true"
          :height="700"
        >
        <template v-slot:item="props">
          <tr>
            <td style="font-size:.8em" class="text-xs">{{ props.item.user_name }}</td>
            <td  style="font-size:.8em" class="text-xs">
              {{ props.item.user_role }}
            </td>
            <td  style="font-size:.8em" class="text-xs">
              {{ props.item.table_name }}
            </td>
            <td  style="font-size:.8em" class="text-xs-left">
              {{ props.item.operation }}
            </td>
            <td style="font-size:.8em" class="text-xs-left">
              {{ props.item.target }}
            </td>
            <td style="font-size:.8em" class="text-xs-right">
              {{ props.item.description }}
            </td>
            <td style="font-size:.8em">
              {{ props.item.when_entered | moment("YYYY-MM-DD h:mma") }}
            </td>
            <td class="text-xs-center">
            </td>
          </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')

export default {
  data: () => ({
    user: fb.session.user,
    params: {
      user_uid: '',
      target: '',
      table: '',
      limit: 100
    },
    items: [],
    table: {
      search: '',
      headers: [
        { text: 'User', value: 'user_name' },
        { text: 'User Role', value: 'user_role' },
        { text: 'Table', value: 'table_name' },
        { text: 'Operation', value: 'operation' },
        { text: 'Target', value: 'target' },
        { text: 'Description', value: 'description' },
        { text: 'When Entered', value: 'when_entered' }
      ]
    }
  }),
  watch: {
  },
  mounted () {
    this.search()
  },
  methods: {
    search: function () {
      var self = this
      console.log(this.params)
      api.audit.get(this.params, (data) => {
        console.log(data)
        self.items = data
      })
    }
  }
}
</script>
